const IP_URL = process.env.NODE_API_URL

export const insertTravel = async (
  input_data,
  is_automatic,
  quantity_travel,
  config_inputs
) => {
  try {
    const response = await fetch(
      IP_URL + "api_travels/insert_travels",
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          input_data:input_data,
          is_automatic:is_automatic,
          quantity_travel: quantity_travel,
          config_inputs: config_inputs,
        }),
      }
    );
    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error al iniciar sesión", error);
  }
};

export const UpdateTravel = async (
  input_data,
  is_all_travels,
  config_inputs,
  travel_id
) => {
  try {
    const response = await fetch(
      IP_URL + "api_travels/update_travels",
      {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          input_data:input_data,
          is_all_travels:is_all_travels,
          config_inputs: config_inputs,
          travel_id: travel_id
        }),
      }
    );
    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error al iniciar sesión", error);
  }
};

export const GetTravelById = async (travel_id) => {
  try {
    const response = await fetch(
      IP_URL + "api_travels/travel_by_id",
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          travel_id: travel_id,
        }),
      }
    );
    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error al iniciar sesión", error);
  }
};

export const DeleteTravelById = async (travel_id) => {
  try {
    const response = await fetch(
      IP_URL + "api_travels/delete_travels",
      {
        method: "DELETE",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          travel_id: travel_id,
        }),
      }
    );
    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error al iniciar sesión", error);
  }
};
